// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_0cbff81"};